import { render, staticRenderFns } from "./NewsNotification.vue?vue&type=template&id=1b0c902f"
import script from "./NewsNotification.vue?vue&type=script&lang=ts"
export * from "./NewsNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports